import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
  {
    id: 1,
    name: "María Fernanda Rodríguez",
    location: "Pasto, Nariño",
    membershipTier: "Elite",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_189ebc4b0-1763296929116.png",
    avatarAlt: "Professional headshot of Hispanic woman with long dark hair wearing elegant blue blouse smiling warmly",
    rating: 5,
    text: "BIZZNET ha transformado mi forma de comprar. Con mi membresía Elite, he ahorrado más de $500.000 COP en solo dos meses. Los descuentos son reales y los negocios son de excelente calidad.",
    date: "15/11/2025",
    verified: true
  },
  {
    id: 2,
    name: "Carlos Andrés Muñoz",
    location: "Pasto, Nariño",
    membershipTier: "Emprendedor",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103972665-1763296698542.png",
    avatarAlt: "Professional headshot of Hispanic man with short black hair wearing formal navy suit and white shirt",
    rating: 5,
    text: "El programa de afiliados es increíble. Ya he ganado $800.000 COP en comisiones refiriendo a mis amigos. La plataforma es fácil de usar y el soporte es excelente.",
    date: "28/11/2025",
    verified: true
  },
  {
    id: 3,
    name: "Laura Sofía Gómez",
    location: "Pasto, Nariño",
    membershipTier: "Explorador",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19689645b-1763293794554.png",
    avatarAlt: "Professional headshot of young Hispanic woman with curly brown hair wearing casual green sweater smiling brightly",
    rating: 5,
    text: "Como estudiante, cada peso cuenta. Con BIZZNET puedo acceder a descuentos en restaurantes y tiendas que frecuento. La inversión de $20.000 se recupera rápidamente.",
    date: "05/11/2025",
    verified: true
  },
  {
    id: 4,
    name: "Jorge Luis Benavides",
    location: "Pasto, Nariño",
    membershipTier: "Elite",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_176507985-1763292759316.png",
    avatarAlt: "Professional headshot of mature Hispanic man with gray hair wearing business casual attire with confident expression",
    rating: 5,
    text: "Tengo mi propio negocio registrado en BIZZNET y también soy usuario. Es una plataforma win-win. Atraigo nuevos clientes y ahorro en mis compras personales.",
    date: "20/11/2025",
    verified: true
  }];


  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials?.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials?.length) % testimonials?.length);
  };

  const currentTestimonial = testimonials?.[currentIndex];

  return (
    <section className="py-20 px-6 bg-background">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4">
            Lo Que Dicen Nuestros Usuarios
          </h2>
          <p className="text-lg text-muted-foreground">
            Testimonios reales de la comunidad BIZZNET en Colombia
          </p>
        </div>

        <div className="relative">
          <div className="bg-card rounded-2xl shadow-lg p-8 md:p-12">
            <div className="flex flex-col md:flex-row gap-8 items-center">
              <div className="flex-shrink-0">
                <div className="relative">
                  <div className="w-24 h-24 rounded-full overflow-hidden border-4 border-primary">
                    <Image
                      src={currentTestimonial?.avatar}
                      alt={currentTestimonial?.avatarAlt}
                      className="w-full h-full object-cover" />

                  </div>
                  {currentTestimonial?.verified &&
                  <div className="absolute -bottom-2 -right-2 bg-success text-success-foreground rounded-full p-1.5">
                      <Icon name="BadgeCheck" size={20} />
                    </div>
                  }
                </div>
              </div>

              <div className="flex-1 text-center md:text-left">
                <div className="flex items-center justify-center md:justify-start gap-1 mb-3">
                  {[...Array(currentTestimonial?.rating)]?.map((_, i) =>
                  <Icon key={i} name="Star" size={20} color="var(--color-accent)" className="fill-current" />
                  )}
                </div>

                <blockquote className="text-lg text-foreground mb-4 italic">
                  "{currentTestimonial?.text}"
                </blockquote>

                <div className="space-y-2">
                  <div className="font-bold text-foreground text-xl">
                    {currentTestimonial?.name}
                  </div>
                  <div className="flex items-center justify-center md:justify-start gap-4 text-sm text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="MapPin" size={16} />
                      {currentTestimonial?.location}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Crown" size={16} />
                      {currentTestimonial?.membershipTier}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Calendar" size={16} />
                      {currentTestimonial?.date}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="absolute top-1/2 -translate-y-1/2 -left-4 md:-left-6">
            <Button
              variant="outline"
              size="icon"
              onClick={prevTestimonial}
              className="w-12 h-12 rounded-full bg-card shadow-lg">

              <Icon name="ChevronLeft" size={24} />
            </Button>
          </div>

          <div className="absolute top-1/2 -translate-y-1/2 -right-4 md:-right-6">
            <Button
              variant="outline"
              size="icon"
              onClick={nextTestimonial}
              className="w-12 h-12 rounded-full bg-card shadow-lg">

              <Icon name="ChevronRight" size={24} />
            </Button>
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {testimonials?.map((_, index) =>
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-3 h-3 rounded-full transition-all ${
            currentIndex === index ? 'bg-primary w-8' : 'bg-border'}`
            }
            aria-label={`Go to testimonial ${index + 1}`} />

          )}
        </div>
      </div>
    </section>);

};

export default TestimonialCarousel;